import user from 'shared_features/lakupandai/store/modules/user';
import mitraItems from './modules/mitraItems';

export default {
  modules: {
    user,
    mitraItems,
  },
};
